import { createFileRoute } from "@tanstack/react-router";
import { safeJsonLd } from "@/lib/structured-data";
import { bookingPageCrumbs, getClinicStructuredData } from "@/lib/structured-data/clinic";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

// Booking page for the Lincoln Park, Chicago clinic (939 W. North Avenue, Suite 750, Chicago, IL 60642). The clinic has no
// appointment type of its own in Acuity. The embed opens the public "Illinois
// Locations" type (26951941) with calendarID=6116205, which limits the
// scheduler to this one clinic calendar.
export const Route = createFileRoute("/schedule-a-consult/lincoln-park")({
  head: () => ({
    meta: [
      // Indexable since 3 Oct 2026, as on the old production site (Wayback
      // 2025 shows "index, follow"). The sitemap lists this page.
      { title: "Schedule FREE Hair Consultation in Lincoln Park, Chicago" },
      {
        name: "description",
        content:
          "Schedule a free hair restoration consult with RESTORE in Lincoln Park, Chicago, in person or by video. Our client advisors will answer your questions.",
      },
      {
        property: "og:title",
        content: "Schedule FREE Hair Consultation in Lincoln Park, Chicago",
      },
      {
        property: "og:description",
        content:
          "Book a free in-person or virtual hair restoration consultation with RESTORE in Lincoln Park, Chicago.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/lincoln-park/",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({
          "@graph": getClinicStructuredData("lincoln-park", bookingPageCrumbs("Lincoln Park", "/schedule-a-consult/lincoln-park/")),
        }),
      },
    ],
  }),
  component: ScheduleLincolnParkPage,
});

function ScheduleLincolnParkPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Lincoln Park, Chicago
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&appointmentType=26951941&calendarID=6116205" />
        </div>
      </main>
      <Footer />
    </div>
  );
}
